<div (click)="dismiss()">
  <div class="alert alert--minimal">
    <div class="alert__icon">
      <mat-icon class="alert-color-red">warning</mat-icon>
    </div>

    <div class="alert__message">
      <p>A newer version of Messenger is available. Please save your work and <a (click)="refresh(); $event.stopPropagation()">refresh</a> the page.</p>
      <p><a (click)="refresh(); $event.stopPropagation()">Refresh Now</a></p>
    </div>
  </div>
</div>
